module.exports = __webpack_public_path__ + "static/logo-sodexo-b9d4b7fe114419c1ce486109b9c64703.png";